import { Typography } from '@packages/uiKit/Typography';
import styled from 'styled-components';

export const StyledAmountCell = styled(Typography).attrs({ weight: 700 })``;
